import BaseItemModel, { BaseItemData } from 'jsx/models/baseItem';

export interface SubscriptionItemData extends BaseItemData {
  itemId: number;
  productVariantId: number;
  productId: number;
  quantity: number;
  isDeferrable?: boolean;
  isDeferred?: boolean;
}

export default class SubscriptionItemModel extends BaseItemModel {
  constructor(data: SubscriptionItemData) {
    super(data);
    this.itemId = data.itemId;
    this.productVariantId = data.productVariantId;
    this.productId = data.productId;
    this.quantity = data.quantity;
    this.isDeferrable = data.isDeferrable ?? false;
    this.isDeferred = data.isDeferred ?? false;
  }

  readonly itemId: number;

  readonly productVariantId: number;

  readonly productId: number;

  readonly quantity: number;

  readonly isDeferrable: boolean;

  readonly isDeferred: boolean;
}
